import { useMemo } from "react";
import { useGetCalendarEventTypesQuery } from "app/services/api/calendarApi";

export const useCalendarEventTypes = () => {
  const { data, isLoading, isError } = useGetCalendarEventTypesQuery();

  const friendlyNames = useMemo(() => {
    if (!data?.event_types) return {};
    return data.event_types.reduce<Record<string, string>>((acc, type) => {
      acc[type.value] = type.label;
      return acc;
    }, {});
  }, [data]);

  return { friendlyNames, isLoading, isError };
};
